import {
  GET_DISPOSAL,
  GET_DISPOSAL_SUCCESS,
  GET_DISPOSAL_FAIL,
  DELETE_DISPOSAL,
  DELETE_DISPOSAL_SUCCESS,
  DELETE_DISPOSAL_FAIL,
  UPDATE_DISPOSAL,
  UPDATE_DISPOSAL_SUCCESS,
  UPDATE_DISPOSAL_FAIL,
  ADD_NEW_DISPOSAL,
  ADD_DISPOSAL_SUCCESS,
  ADD_DISPOSAL_FAIL,
  DISPOSAL_LOADING,
  DISPOSAL_RESET,
  DISPOSAL_RESET_CREATE
} from "./actionType";

export const resetDisposalState = (actionType) => ({
  type: DISPOSAL_RESET,
  payload: { actionType },
});


export const resetDisposalCreateState = (actionType) => ({
  type: DISPOSAL_RESET_CREATE,
  payload: { actionType }
});

export const getDisposalSuccess = (actionType, data) => ({
  type: GET_DISPOSAL_SUCCESS,
  payload: { actionType, data },
});

export const getDisposalFail = (actionType, error) => ({
  type: GET_DISPOSAL_FAIL,
  payload: { actionType, error },
});

export const getDisposal = data => ({
  type: GET_DISPOSAL,
  payload: data,
});

export const getDisposalLoading = () => ({
  type: DISPOSAL_LOADING
});

export const deleteDisposal = data => ({
  type: DELETE_DISPOSAL,
  payload: data,
});

export const deleteDisposalSuccess = data => ({
  type: DELETE_DISPOSAL_SUCCESS,
  payload: data,
});

export const deleteDisposalFail = error => ({
  type: DELETE_DISPOSAL_FAIL,
  payload: error,
});

export const updateDisposal = data => ({
  type: UPDATE_DISPOSAL,
  payload: data,
});

export const updateDisposalFail = error => ({
  type: UPDATE_DISPOSAL_FAIL,
  payload: error,
});

export const updateDisposalSuccess = data => ({
  type: UPDATE_DISPOSAL_SUCCESS,
  payload: data,
});

export const addNewDisposal = data => ({
  type: ADD_NEW_DISPOSAL,
  payload: data,
});

export const addDisposalSuccess = data => ({
  type: ADD_DISPOSAL_SUCCESS,
  payload: data,
});

export const addDisposalFail = error => ({
  type: ADD_DISPOSAL_FAIL,
  payload: error,
});